import { watch } from "vue";

/**
 * Creates a watch to fill in the pricing details when the forms payment type is updated 
 * so the pricing is adjusted throughout the state
 * 
 * @param {Object} data 
 * @param {Object} form 
 * @returns {Function} cancels the watch when executed
 */
export function createFormFieldPaymentTypeWatch(data, form){
    return watch(
        () => form.fields.value.payment_type,
        (paymentType) => data.pricing.payment_type.value = paymentType?.value,
        { deep: true } 
    )
}